import { z } from 'zod';
import { roleSchema } from './role';
import { organizationSchema } from './organization';
export const adminSchema = z.object({
  id: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  email: z.string(),
  phone: z.string(),
  status: z.string(),
  cognitoID: z.string(),
  role: z
    .lazy(() => roleSchema)
    .optional()
    .nullable(),
  organization: z
    .lazy(() => organizationSchema)
    .optional()
    .nullable(),
  roleID: z.string().optional().nullable(),
  organizationID: z.string().optional().nullable(),
  providerID: z.string().optional().nullable(),
});
